// src/utils/dates.js
export const fmtDate = (ts) => {
  if (!ts) return '-';
  if (ts?._seconds) return new Date(ts._seconds * 1000).toLocaleString('fi-FI');
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('fi-FI');
};

export const fmtDateTime = (ts) => {
  if (!ts) return "—";
  try {
    const d =
      typeof ts === "number"
        ? new Date(ts)
        : typeof ts?.toMillis === "function"
        ? new Date(ts.toMillis())
        : typeof ts?._seconds === "number"
        ? new Date(ts._seconds * 1000)
        : new Date(ts);
    return d.toLocaleString("fi-FI", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};